import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { objectify, fetchPost } from '../../utils';

export const fetch = async (query: { ProductId: number; filters: any; Warehouse: string; LotSerial: any; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, filters, Warehouse, LotSerial, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchPost(
    `/InventoryEnquiry/Stocking/AllocationDetails/InputAways/Product/${ProductId}/Warehouse/${Warehouse}/LotDetails/${LotSerial}/SearchInputAways`,
    { ...filters, LotSerial },
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        InPutAways: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.InPutAways) {

            return {
              records: result.InPutAways.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
